export const allTasksActionTypes = {
  SET_ALL_DATA: 'SET_ALL_DATA',
  SET_TEMP_DATA: 'SET_TEMP_DATA',
  SET_SEARCH_DATA: 'SET_SEARCH_DATA',
  SET_SEARCH_ASSIGNEE_DATA: 'SET_SEARCH_ASSIGNEE_DATA',
  SET_SEARCH_STATUS_DATA: 'SET_SEARCH_STATUS_DATA',
  SET_SEARCH_PRIORITY_DATA: 'SET_SEARCH_PRIORITY_DATA',
};
